// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8955 ? "b1727621" : chunkId) + "." + {"8009":"714bf0024c597ae7","8955":"3cccf6ba8e08e3c6"}[chunkId] + ".js";
};